import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

export interface ErrorSnackbarData {
	message: string;
}

@Component({
	selector: "app-error-snackbar",
	template: `
		<div class="error-snackbar-container">
			<mat-icon class="error-icon">error</mat-icon>
			<span class="error-message">{{ message }}</span>
		</div>
	`,
	styles: [
		`
			:host {
				display: block;
				width: 100%;
			}

			.error-snackbar-container {
				display: flex;
				align-items: center;
			}

			.error-icon {
				color: #c94318;
				font-size: 20px;
				width: 20px;
				height: 20px;
				flex-shrink: 0;
				margin-right: 12px;
			}

			.error-message {
				font-weight: 500;
				font-size: 14px;
				flex: 1;
			}
		`,
	],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatIconModule],
})
export class ErrorSnackbarComponent {
	message: string;

	constructor(
		public snackBarRef: MatSnackBarRef<ErrorSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: ErrorSnackbarData,
	) {
		this.message = data.message;
	}
}
